import ajax from '@/libs/api.request'

export default {
  signup:param=>{
    return ajax.get('edu/web/biz/signup',param);
  },
}
